import api from './api';
import { 
  RegistroLimpieza, 
  CrearRegistroLimpieza, 
  ActualizarRegistroLimpieza, 
  RutaDto,
  ApiResponse,
  PaginatedResultDto
} from '../types';

// Con señal débil una petición puede quedar colgada; pasado este tiempo el QR guarda
// el registro en el celular y lo envía después.
export const REGISTRO_TIMEOUT_MS = 15000;

export const registroLimpiezaService = {

  async createRegistroLimpieza(registro: CrearRegistroLimpieza): Promise<ApiResponse<RegistroLimpieza>> {
    try {
      const response = await api.post('/RegistroLimpieza', registro, { timeout: REGISTRO_TIMEOUT_MS });
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al crear el registro de limpieza',
        errors: error.response?.data?.errors || [],
        sinConexion: !error.response,
      };
    }
  },

  async updateRegistroLimpieza(id: number, registro: ActualizarRegistroLimpieza): Promise<ApiResponse<RegistroLimpieza>> {
    try {
      const response = await api.put(`/RegistroLimpieza/${id}`, registro, { timeout: REGISTRO_TIMEOUT_MS });
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al actualizar el registro de limpieza',
        errors: error.response?.data?.errors || [],
        sinConexion: !error.response,
      };
    }
  },

  async deleteRegistroLimpieza(id: number): Promise<ApiResponse<void>> {
    try {
      await api.delete(`/RegistroLimpieza/${id}`);
      return { success: true };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al eliminar el registro de limpieza',
        errors: error.response?.data?.errors || []
      };
    }
  },

  // Métodos paginados
  async getRegistrosLimpiezaPaginated(page: number = 1, pageSize: number = 50): Promise<ApiResponse<PaginatedResultDto<RegistroLimpieza>>> {
    try {
      const response = await api.get('/RegistroLimpieza/paginated', {
        params: { page, pageSize }
      });
      return {
        success: true,
        data: response.data,
        message: 'Registros paginados obtenidos exitosamente',
        errors: undefined,
      };
    } catch (error: any) {
      return {
        success: false,
        data: undefined,
        message: error.response?.data?.message || 'Error al obtener registros paginados',
        errors: error.response?.data?.errors || undefined,
      };
    }
  },

  async getRegistrosFilteredPaginated(
    page: number = 1, 
    pageSize: number = 50,
    searchTerm?: string,
    usuarioId?: number,
    estado?: string,
    fechaInicio?: string,
    fechaFin?: string
  ): Promise<ApiResponse<PaginatedResultDto<RegistroLimpieza>>> {
    try {
      const params: any = { page, pageSize };
      if (searchTerm) params.searchTerm = searchTerm;
      if (usuarioId) params.usuarioId = usuarioId;
      if (estado && estado !== 'todos') params.estado = estado;
      if (fechaInicio) params.fechaInicio = fechaInicio;
      if (fechaFin) params.fechaFin = fechaFin;

      const response = await api.get('/RegistroLimpieza/filtered', { params });
      return {
        success: true,
        data: response.data,
        message: 'Registros filtrados obtenidos exitosamente',
        errors: undefined,
      };
    } catch (error: any) {
      return {
        success: false,
        data: undefined,
        message: error.response?.data?.message || 'Error al obtener registros filtrados',
        errors: error.response?.data?.errors || undefined,
      };
    }
  },

  async getRutasByRangoFechas(fechaInicio: string, fechaFin: string, usuarioId?: number): Promise<ApiResponse<RutaDto[]>> {
    try {
      const params = new URLSearchParams({
        fechaInicio,
        fechaFin
      });
      if (usuarioId) {
        params.append('usuarioId', usuarioId.toString());
      }
      const response = await api.get(`/RegistroLimpieza/ruta/todos?${params}`);
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        data: undefined, 
        message: error.response?.data?.message || 'Error al obtener rutas',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async getUsuariosActivos(): Promise<ApiResponse<any[]>> {
    try {
      const response = await api.get('/RegistroLimpieza/usuarios');
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        data: undefined, 
        message: error.response?.data?.message || 'Error al obtener usuarios',
        errors: error.response?.data?.errors || []
      };
    }
  }
}; 
